import i18next from 'i18next';
import admin_en from '../admin/admins/locales/en/translations';
import brand_en from '../admin/brand/locales/en/translations';
import merchant_en from '../admin/brand/locales/en/translations';
import checkout_en from '../admin/checkout/locales/en/translations';
import common_en from '../common/locales/en/translations';
import home_en from '../public/locales/en/translations.json';
import login_en from '../login/locales/en/translations';
import tag_en from '../admin/tag/locales/en/translations';
import ticket_en from '../admin/ticket/locales/en/translations';
import centralsPurchasing_en from '../admin/centralPurchasing/locales/en/translations';
import centralsPurchasing_fr from '../admin/centralPurchasing/locales/fr/translations';
import user_en from '../admin/users/locales/en/translations';
import admin_fr from '../admin/admins/locales/fr/translations';
import brand_fr from '../admin/brand/locales/fr/translations';
import checkout_fr from '../admin/checkout/locales/fr/translations';
import common_fr from '../common/locales/fr/translations';
import home_fr from '../public/locales/fr/translations.json';
import login_fr from '../login/locales/fr/translations';
import merchant_fr from '../admin/merchant/locales/fr/translations';
import tag_fr from '../admin/tag/locales/fr/translations';
import ticket_fr from '../admin/ticket/locales/fr/translations';
import user_fr from '../admin/users/locales/fr/translations';
import billing_fr from '../admin/billing/locales/fr/translations';
import billing_en from '../admin/billing/locales/en/translations';
import products_en from '../admin/products/locales/en/translations';
import products_fr from '../admin/products/locales/fr/translations';
import stripe_en from '../admin/stripe/locales/en/translations';
import stripe_fr from '../admin/stripe/locales/fr/translations';
import campaign_en from '../admin/campaign/locales/en/translations';
import campaign_fr from '../admin/campaign/locales/fr/translations';
import dashboard_en from '../admin/dashboard/locales/en/translations';
import dashboard_fr from '../admin/dashboard/locales/fr/translations';

export default () => {
  i18next.init({
    ns: ['homepage', 'common', 'brand', 'ticket', 'merchant', 'login', 'billing', 'products', 'stripe', 'campaign', 'dashboard'],
    defaultNS: 'moduleA',
    interpolation: {escapeValue: false},
    lng: 'fr',
    resources: {
      fr: {
        homepage: home_fr,
        brand: brand_fr,
        ticket: ticket_fr,
        merchant: merchant_fr,
        common: common_fr,
        login: login_fr,
        admin: admin_fr,
        centralPurchasing: centralsPurchasing_fr,
        user: user_fr,
        checkout: checkout_fr,
        tag: tag_fr,
        billing: billing_fr,
        products: products_fr,
        stripe: stripe_fr,
        campaign: campaign_fr,
        dashboard: dashboard_fr,
      },
      en: {
        homepage: home_en,
        brand: brand_en,
        ticket: ticket_en,
        merchant: merchant_en,
        common: common_en,
        login: login_en,
        admin: admin_en,
        centralPurchasing: centralsPurchasing_en,
        user: user_en,
        checkout: checkout_en,
        tag: tag_en,
        billing: billing_en,
        products: products_en,
        stripe: stripe_en,
        campaign: campaign_en,
        dashboard: dashboard_en,
      },
    },
  });
};
